var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatfish(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 197.99 57.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:none;stroke:#2772af;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M67.8,11.31c1.1-1.4,2.2-2.7,3.3-4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M87.4,43.11c2.5,1.3,4.4,2,7.1,2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M44.8,29.01c1.7,1.3,2.9,2.2,4.8,3.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M182.8,23.81c4,.1,8,.3,12,.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M182.8,29.61c4,.1,8,.3,12,.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M181.6,32.71c2.1,.8,4.2,1.9,6.3,2.7,3,1.1,7.1,2.2,8-2.1,0,0,.2-9.9,0-10.7-.2-.8-.1-2.9-2-4.4-2-1.5-8.1,1.2-8.1,1.2l-4.1,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M95,42.21c9.9-2.1,21.1-2.6,31.2-3.7,15.9-1.7,26.5-2.8,42.3-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M41.9,24.11c1.1,0,2.3,.1,3.4,.2,1.6,.1,3.2,.4,4.6,1.1,.9,.5,2.4,2.1,2.3,3.3,0,.4-2,4-3.1,6.2-.6,1-1.7,1.6-2.9,1.5s-2.7-.5-3.3-1.2c-1.1-1.4-2.2-4.4-3.1-4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M30.9,14.31c1.3,.3,2.4,.9,3.4,1.7,1.1,.9,2,2.2,2.2,3.6,.3,1.7-.4,3.4-1.2,4.9-.9,1.5-1.9,2.9-2.7,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M14.2,35.51c2.1,.1,4.9-.7,6.4-2.3,2-2.2,2.7-3.6,3.9-6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M94.9,42.81c3.1,.5,8.2,4,8.2,4,7.6-1,15.2-1.8,22.8-2.7,13-1.5,26-2.5,38.9-4.1,4.6-.6,6.7-.2,9.7-4.4,1.6-2.3-1.6-2,7-2.9l.2-11.9c-8.8-1.5-14.5-1.8-21.7-2.8-6.8-1-13.8-.4-20.7-.5-18.7-.4-31-3.2-48.3-4.3-13.8-.8-24.4-1.9-36.6-1.6-7.7,.2-12.7,1.5-20.4,2.4-4.8,.5-9.6,1.7-14.2,3.2-6.1,2-15.6,4.5-17.6,11.3-.7,2.3,.5,3.7,2.7,4.5,6.4,2.4,13.4,3.3,20.1,4.5,9.8,1.7,19.5,4.4,29.4,5.5,8.5,1,17.1,.5,25.6-.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M85.9,38.31s4.5,1.1,6.6,1.9c.3,.1,.5,.2,.8,.4,.8,.5,1.3,1.3,1.5,2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M77.6,40.21s1.1,1,2.4,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M94.9,42.81c.5,1.5,0,3.4-1.3,4.5-.7,.6-1.3,1.1-1.7,1.3-1.7,.6-5-1.1-6.5-1.8-1-.5-3.4-2.6-5.3-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M61.7,11.51s6.3-7.3,7.5-8.2c1.4-1,5-2.1,6.4-.5,1,1.1,1.2,3.8,.9,4.8-.3,1-3.6,4.4-3.6,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M12.4,35.21c-1.6,1.9-1.6,4.6-1,6.9s1.8,4.5,2.4,6.9,.4,5-1.3,6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M6.3,34.61c-1.6,1.9-1.6,4.7-1,7.1s1.8,4.6,2.4,7.1c.6,2.4,.4,5.2-1.3,7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M7.9,11.51c-.8,1-.8,2.3-.5,3.5s.9,2.3,1.2,3.5c.3,1.1,.3,2.5-.6,3.4"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 15.7,
    cy: 25.11,
    r: 2.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatfish);
export default __webpack_public_path__ + "static/media/Catfish.e5220ffa42a817be7ba5e34a0fba88eb.svg";
export { ForwardRef as ReactComponent };